type DateRange = {
  startDate: string | undefined;
  endDate: string | undefined;
};

function getDateRange(timePeriodValue: string): DateRange {
  const now = new Date();
  const endDate = now.toISOString();
  let startDate: Date;

  switch (timePeriodValue) {
    case '7d':
      startDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      break;
    case '30d':
      startDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
      break;
    case '3m':
      startDate = new Date(now);
      startDate.setMonth(startDate.getMonth() - 3);
      break;
    default:
      return { startDate: undefined, endDate: undefined };
  }

  return { startDate: startDate.toISOString(), endDate };
}

export default getDateRange;
